export enum AirwayConstants {
  SET_VERIFICATION_METHODS = 'airway/SET_VERIFICATION_METHODS',
  SET_LENGTH_BASED_TAPE_MEASURE = 'airway/SET_LENGTH_BASED_TAPE_MEASURE',
  SET_LENGTH_BASED_TAPE_MEASURE_PNNV = 'airway/SET_LENGTH_BASED_TAPE_MEASURE_PNNV',
  SET_STATUS = 'airway/SET_STATUS',
  SET_SECURED_VIA = 'airway/SET_SECURED_VIA',
  SET_TUBE_SIZE = 'airway/SET_TUBE_SIZE',
  SET_TUBE_SIZE_UNIT = 'airway/SET_TUBE_SIZE_UNIT',
  SET_DEPTH = 'airway/SET_DEPTH',
  SET_EXAM = 'airway/SET_EXAM',
  SET_INITIAL_ASSESSMENT_AIRWAY_COMMENTS = 'airway/SET_INITIAL_ASSESSMENT_AIRWAY_COMMENTS',
  SET_PERFORMED_BY = 'airway/SET_PERFORMED_BY',
  SET_OUTCOME = 'airway/SET_OUTCOME',
  SAVE_INITIAL_ASSESSMENT_AIRWAY = 'airway/SAVE_INITIAL_ASSESSMENT_AIRWAY',
  RESET_INITIAL_ASSESSMENT_AIRWAY = 'airway/RESET_INITIAL_ASSESSMENT_AIRWAY',
  SAVE_INITIAL_ASSESSMENT_AIRWAY_NABC = 'airway/SAVE_INITIAL_ASSESSMENT_AIRWAY_NABC',
  SET_TUBE_SIZE_UNIT_CLIENT = 'airway/SET_TUBE_SIZE_UNIT_CLIENT',
}
